import React from 'react';

import { useMapContext } from 'shared/context';
import { MAP } from 'shared/constants';
import { Button, Card } from 'components';

export const ButtonSnapPosition = (): JSX.Element => {
  const { setLat, setLong, map } = useMapContext();

  const error = () => alert('Unable to retrieve your location');
  const success = (position: GeolocationPosition) => {
    if (!map) return;
    const newLat = position.coords.latitude;
    const newLong = position.coords.longitude;
    map.setView([newLat, newLong], MAP.ZOOM);
    setLat(newLat);
    setLong(newLong);
  };

  const onMyPositionClick = () => {
    if (!navigator.geolocation) {
      alert('Geolocation is not supported by your browser');
    } else {
      navigator.geolocation.getCurrentPosition(success, error);
    }
  };

  return (
    <Card column align justify>
      <Button onClick={onMyPositionClick}>Snap to my position</Button>
    </Card>
  );
};
